import type { HttpCancelToken } from "@okapi/http";
import { api } from "api";

export type ProductParams = {
    id: string;
    quantity: number;
    price?: number;
};

export type PullListItem = {
    id: string;
    type: string;
    products: ProductParams[];
    storeId: string;
    country?: string;
};

export type PullList = {
    BASKET: PullListItem[];
};

export const pullList = (country: string, cancelToken?: HttpCancelToken) => {
    return api.get<PullList>(`/aem_bws/v3/pullLists`, {
        listTypes: 'BASKET',
        ...(country && { country })
    }, {
        cancelToken
    });
};

export type PushList = {
    list: PullListItem;
};

export const pushList = (params: PushList, cancelToken?: HttpCancelToken) => {
    return api.post<void, PushList>(`/aem_bws/v3/pushList`, params, {
        cancelToken
    });
};

export const EVENT_ID_BASKET_LOGIC = 707;

export type LogParams = {
    type: string;
    eventId: number;
    description: string;
    data: Record<string, unknown>;
    checkoutSessionId?: string;
};

export const log = (params: Partial<LogParams>) => {
    return api.post<void, LogParams>(`/ls/api/v1/log`, {
        type: 'info',
        eventId: EVENT_ID_BASKET_LOGIC,
        description: '',
        data: {},
        ...params
    });
};